import { calc_mavr } from './avrg-lines.js';
import { cleanMarkers, deleteGraphById, filterOutDatesByTimescope } from './graph-helpers.js';
export function drawChart(startprice, itemsEx, itemsExDrops, itemsExRises, itemsExLines, targetElemId, dropCount, riseCount, lastDate, timescope, assetType) {

    return new Promise((resolve, reject) => {
        var groups = new vis.DataSet();

        //**** moving average ****//

        var line200 = $('input[name="graph-line200[' + targetElemId + ']"]:checked').val() ? true : false;
        var line50 = $('input[name="graph-line50[' + targetElemId + ']"]:checked').val() ? true : false;

        var moving_avr200 = itemsEx;
        var moving_avr50 = itemsEx;

        if (line200) moving_avr200 = calc_mavr(itemsEx, 40 * 7, 3);
        if (line50) moving_avr50 = calc_mavr(itemsEx, 10 * 7, 4);

        //itemsEx = filterOutDatesByTimescope(itemsEx, timescope);

        lastDate = itemsEx[itemsEx.length - 1]["x"];
        var lastPrice = itemsEx[itemsEx.length - 1]["y"];

        if (line200) itemsEx = itemsEx.concat(moving_avr200);
        if (line50) itemsEx = itemsEx.concat(moving_avr50);

        var drops_checked = $('input[name="graph-drops[' + targetElemId + ']"]:checked').val() ? true : false;
        if (drops_checked) itemsEx = itemsEx.concat(itemsExDrops);

        var rises_checked = $('input[name="graph-rises[' + targetElemId + ']"]:checked').val() ? true : false;
        if (rises_checked) itemsEx = itemsEx.concat(itemsExRises);

        itemsEx = itemsEx.concat(itemsExLines);

        groups.add({
            id: 0,
            content: "Graph",
            className: 'graph-style',
            options: {
                drawPoints: false,
                shaded: {
                    orientation: 'bottom' // top, bottom
                }
            }
        });

        groups.add({
            id: 1,
            content: "median",
            className: 'median-style',
            options: {
                drawPoints: {
                    style: 'circle' // square, circle
                }
            }
        });

        groups.add({
            id: 2,
            content: "Startpreis",
            className: 'startprice-style',
            options: {
                drawPoints:
                {
                    style: 'circle' // square, circle
                }
            }
        });

        groups.add({
            id: 3,
            content: "MovingAVRG200",
            className: 'mavrg200-style',
            options: {
                drawPoints: false,
                shaded: {
                    orientation: 'bottom' // top, bottom
                }
            }
        });

        groups.add({
            id: 4,
            content: "MovingAVRG50",
            className: 'mavrg50-style',
            options: {
                drawPoints: false,
                shaded: {
                    orientation: 'bottom' // top, bottom
                }
            }
        });
        /* make marker for drops */
        for (var i = 5; i < dropCount + 5; i++) {
            groups.add({
                id: i,
                content: "marker2",
                className: 'marker-style',
                options: {
                    drawPoints: {
                        style: 'circle' // square, circle
                    },
                    shaded: {
                        orientation: 'bottom' // top, bottom
                    }
                }
            });
        }

        for (var i = dropCount + 5; i < dropCount + riseCount + 5; i++) {
            groups.add({
                id: i,
                content: "marker2",
                className: 'marker-style-rise',
                options: {
                    drawPoints: {
                        style: 'circle' // square, circle
                    },
                    shaded: {
                        orientation: 'bottom' // top, bottom
                    }
                }
            });
        }

        var container = document.getElementById('visualization_' + targetElemId);
        container.innerHTML = "";

        //shorten array according to timescope	
        var reducedGraph = new Array();
        var now = new Date();

        var x_month_ago = new Date().setDate(now.getDate() - (timescope * 30));

        //var x_month_agoStr = new Date(x_month_ago);
        var len = itemsEx.length;

        var lastentry = 0;
        for (var i = 0; i < len; i++) {

            var date1 = new Date(itemsEx[i]["x"]);
            if (date1 > x_month_ago || itemsEx[i]["group"] == 1 || itemsEx[i]["group"] == 2) {
                var tmp = itemsEx[i];

                tmp['id'] = i;
                if (itemsEx[i]["group"] == 0) lastentry = i;
                //draw median line between first and last value
                if ((itemsEx[i]["group"] == 1)) {
                    if ("label" in itemsEx[i]) {
                        tmp["label"]["content"] = Math.round((1 - (itemsEx[i]["y"] / reducedGraph[0]["y"])) * -100) + "%";
                        tmp["label"]["xOffset"] = -25;
                        tmp["label"]["className"] = "median-label";

                    } else {
                        tmp["x"] = reducedGraph[0]["x"];
                        tmp["y"] = reducedGraph[0]["y"];
                    }
                }

                //Push array object to new array except current item is myStartprice and myStartprice is not defined/asset not in Portfolio
                if ((itemsEx[i]["group"] != 2)) {
                    reducedGraph.push(tmp);
                }
            }
        }

        var heighestPerView = 5;

        let type = 0;
        if (drops_checked)
            reducedGraph = cleanMarkers(reducedGraph, heighestPerView, type, lastDate);

        type = 1;
        if (rises_checked)
            reducedGraph = cleanMarkers(reducedGraph, heighestPerView, type, lastDate);

        //draw myStartprice line between first and last value
        if (startprice != 0) {
            for (var si = 0; si < 2; si++) {
                var tmp = new Array;
                tmp["x"] = !si ? (itemsEx[0]["x"]) : (itemsEx[lastentry]["x"]);
                tmp["y"] = startprice;
                tmp["group"] = 2;
                if (si) {
                    tmp["label"] = [];
                    tmp["label"]["content"] = I18n["startprice"];
                    tmp["label"]["xOffset"] = -100;
                    tmp["label"]["yOffset"] = -2;
                    tmp["label"]["className"] = "startprice-label";
                }
                reducedGraph.push(tmp);
            }
        }

        // SKIP_WE
        // Add hiddenDates to timeline Options if useralert is from non-crypro asset

        var vis_width = 0;

        vis_width = $('#' + 'visualization_' + targetElemId).parent().parent().parent().width();

        var vis_height = vis_width * 0.5;
        if (vis_width < 600) vis_height = vis_width * 0.6;

        let timemultiplier = timescope*timescope/15;
        timemultiplier = timemultiplier < 1 ? 1 : timemultiplier;
        timemultiplier = timemultiplier > 10 ? 10 : timemultiplier;
        lastDate = new Date(new Date(lastDate).getTime() + ((lastPrice > 1 ? 150000000 : 80000000) * (timemultiplier)));

        if (!reducedGraph[0]) return reject(0);

        var dataset = new vis.DataSet(reducedGraph);
        var timeline_options = {
            start: reducedGraph[0]["x"],
            end: lastDate,
            max: lastDate,
            min: reducedGraph[0]["x"],
            legend: false,
            moveable: false,
            zoomable: false,
            zoomMin: 2 * timescope * 24 * 60 * 60 * 1000,
            zoomMax: 31 * timescope * 24 * 60 * 60 * 1000,
            sampling: false,
            sort: true,
            yAxisOrientation: 'left',
            showCurrentTime: false,
            autoResize: true,
            height: vis_height,
            maxHeight: 500,
            minHeight: 150,
            width: '100%',
            interpolation: { enabled: false, parametrization: 'uniform' },
            dataAxis: {
                showMinorLabels: lastPrice > 1 ? false : true,
                showMajorLabels: false,
                visible: true,
                width: 1,
                /*left: {
                    range: {
                        min: 0,
                    }
                }*/
            }
        };

        if (assetType != "CoreCryptoAsset") {
            // timeline_options.hiddenDates = { start: '1983-02-12 00:00:00', end: '1983-02-14 00:00:00', repeat: 'weekly' };
        }

        deleteGraphById(targetElemId);
        rendered_graphs.push({ obj: new vis.Graph2d(container, dataset, groups, timeline_options), id: targetElemId });
        
        // add gradient to graph
        var successful_gradien = addGradient(targetElemId);
       
        
        var redraw_counter = 0;
        var check_graph_drawn = setInterval(function () {

            if (!successful_gradien) addGradient(targetElemId);
           
            if ($('#visualization_' + targetElemId).find('.graph-style').length > 0) {

                $('#' + 'visualization_' + targetElemId).parent().find('.graph-click').css("visibility", "visible");


                // reorder the DOM of the svg graph to asign a second invisible Graph with wider stroke to use as hover trigger
                    $(".graph-style").each(function () {

                        var _this = this;
                        var parentElement = $(this).closest('svg');
                        // Get a reference to the first child
                        var theFirstChild = parentElement.children(":first");

                        // Clone the graph and insert before the first child to make it the new first child
                        if (!$(this).is(theFirstChild)) {
                            $(_this).clone().insertBefore($(theFirstChild));
                        }
                        // get the new first child (name it hidden-graph to identify it) and make it the invisible graph
                        theFirstChild = parentElement.children(":first");
                        theFirstChild.attr("class", "hidden-graph");
                        theFirstChild.css("stroke-width", "6px");
                        theFirstChild.css("stroke", "transparent");
                        theFirstChild.css("fill", "transparent");
                        theFirstChild.css("fill-opacity", "0.0");

                    });

                    $('.marker-style').bind('click', function () {
                        var _this = this;
                        var vis = $(this).closest('.visualization').attr('id');
                        var result_end = false;
                        $(".marker-style").each(function (i, vis) {
                            if ($(this).is("circle")) result_end = true;
                            if (!result_end && this === _this) {
                                // find the clicked dropcount named i from 0...totaldropcounts in this alert visualizazion
                            }
                        });
                    });

                clearInterval(check_graph_drawn);
                check_graph_drawn = null;
                
                redraw_counter = 0;

                return resolve(reducedGraph);
            }
            else {
                redraw_counter++;
                if (redraw_counter > 10) {
                    clearInterval(check_graph_drawn);
                    check_graph_drawn = null;
                    return reject(0);
                }
            }
        }, 100);
    })


}

export function addGradient(targetElemId) {
    var defsId = $('#visualization_' + targetElemId).find("defs").find("linearGradient").attr("id");
    var cssValue = "url(#"+defsId+") !important";
    var vis_fills = $('#visualization_' + targetElemId).find('.graph-style.vis-fill');

    if (vis_fills.length == 0) return false;

    vis_fills.first().attr('style', function(i,s) { 
        return (s || '') + 'fill: '+cssValue 
    });

    return true;
}